import React from "react";
import { useTranslation } from "react-i18next";

interface ConfirmDeleteModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    messageKey?: string;
}

const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({ isOpen, onClose, onConfirm, messageKey }) => {
    const { t } = useTranslation();

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex p-5 items-center justify-center bg-black bg-opacity-40">
            <div className="bg-white rounded-lg p-6 w-full max-w-md shadow-xl">
                <h2 className="text-lg font-semibold text-darkColor mb-4">{t("delete-confirm-title")}</h2>
                <p className="text-textSecond mb-6">
                    {messageKey ? t(messageKey) : t("delete-confirm-message")}
                </p>
                <div className="flex justify-end gap-4">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 rounded bg-gray-200 text-textSecond hover:bg-gray-300 transition"
                    >
                        {t("cancel")}
                    </button>
                    <button
                        onClick={() => {
                            onConfirm();
                            onClose();
                        }}
                        className="px-4 py-2 rounded bg-red-600 text-white hover:bg-red-700 transition"
                    >
                        {t("confirm-delete")}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmDeleteModal;
